<!-- /* [RECEIVE-ACCEPT-POP] 보낸 신청서 보기(승인) */ -->

<template>
  <div v-if="matchPeople">
    <BasicModal
      :isShowModal="isModal"
      @close-modal="$store.commit('directMatching/setHideModalPopup')"
      title="보낸 신청서 보기"
      disabledFooter
    >
      <div class="popupViewProfile">
        <CorpInfoCard
          v-if="matchPeople.roleName == $role.CORP"
          :data="matchPeople"
        ></CorpInfoCard>
        <UserInfoCard
          v-else-if="matchPeople.roleName == $role.USER"
          :data="matchPeople"
        ></UserInfoCard>
        <h6
          class="popupViewProfileHeadline"
          style="padding-bottom: 0px !important;"
        >
          매칭 프로세스
        </h6>
        <MatchingProcess />

        <section>
          <div class="aRow5">
            <div class="infoBoxForm">
              <div style="margin-bottom: 50px;">
                <h3 class="matchingHeadLine">신청서</h3>
                <LabelInput
                  :label="
                    matchPeople.userRole == $role.CORP
                      ? '신청 대상 기업'
                      : '신청 대상 회원'
                  "
                  :value="matchPeople.name"
                />
                <LabelInput
                  type="textarea"
                  label="매칭신청 사유"
                  :value="selectedDirectMatching.requestReason"
                />
                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine cl-green2">승인서</h3>
                <LabelInput
                  label="연락 담당자 이름"
                  :value="selfAccount.name"
                />
                <LabelInput label="이메일 주소" :value="selfAccount.email" />
                <LabelInput label="전화번호" :value="selfAccount.phoneNumber" />
                <LabelInput
                  type="textarea"
                  label="전달 내용"
                  :value="selectedDirectMatching.responseReason"
                />
              </div>

              <div class="modal-action">
                <MainButton
                  btnText="닫기"
                  color="gray"
                  width="191px"
                  @click="$store.commit('directMatching/setHideModalPopup')"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import MatchingProcess from "@/components/items/MatchingProcess.vue";
import CorpInfoCard from "@/components/items/CorpInfoCard.vue";
import matchingPopupMixins from "@/mixins/matching-popup-mixins";
import LabelInput from "@/components/formControl/LabelInput.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";

export default {
  name: "DirectReceiveAcceptPopup",
  components: {
    BasicModal,
    MainButton,
    MatchingProcess,
    CorpInfoCard,
    LabelInput,
    UserInfoCard,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
  },
  mixins: [matchingPopupMixins],
  data() {
    return {
      form: {},
    };
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
  },
};
</script>
